import { Cookies } from 'react-cookie';

import { AdminDeviceIntakeTrap } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface ApproveTrapResponse {
  status: string;
  trap: AdminDeviceIntakeTrap;
}

export const approveAdminDeviceIntakeTrap = async (serialNumber: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.post<ApproveTrapResponse>(
    `v1/admin/device-intake/traps/${serialNumber}/approve`,
    {},
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};
